// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","slick-slider":"slick-slider","slick-list":"slick-list","slick-track":"slick-track","slick-slide":"slick-slide","slick-prev":"slick-prev","slick-next":"slick-next","slick-current":"slick-current","multiple-images":"multiple-images","leftArrow":"leftArrow","rightArrow":"rightArrow","slick-dots":"slick-dots","dots":"dots","slick-active":"slick-active"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Carousel/css/Carousel.styl
// module id = 1444
// module chunks = 0